export default "__VITE_ASSET__CK0JR7rc__"